import usePrimaryButtonStyle from 'src/components/NavButtons/usePrimaryButtonStyle';
import { Button } from '@mui/material';
import { useFormikContext } from 'formik';
import StepperContext from 'src/store/stepper-context';
import AuthContext from 'src/store/auth-context';
import { useContext } from 'react';
/**
 * CompleteButton is a component that displays a button that submits the form when clicked.
 *
 * @param {Object} props - The props for the component.
 * @param {string} [props.text=''] - The text to display on the button.
 *
 * @returns {JSX.Element} - A JSX element representing the CompleteButton component.
 */
const CompleteButton = ({ text = 'Next' }) => {
  const style = usePrimaryButtonStyle();
  const { handleSubmit } = useFormikContext();
  const { backdoor } = useContext(AuthContext);
  const { nextStep } = useContext(StepperContext);

  const handleOnClick = () => {
    if (backdoor) {
      return nextStep();
    }

    return handleSubmit();
  };

  return (
    <Button
      name="submit"
      color="inherit"
      variant="outlined"
      onClick={handleOnClick}
      data-cy={'continue-button'}
      sx={style}
    >
      {text}
    </Button>
  );
};

export default CompleteButton;
